import React from 'react';
export function NavBar() {
  return <nav style={{
    padding: '16px',
    borderBottom: '1px solid #eee'
  }} data-id="element-1274">
      <a href="/" style={{
      marginRight: '20px'
    }} data-id="element-1275">
        Home
      </a>
      <a href="/blog" style={{
      marginRight: '20px'
    }} data-id="element-1276">
        Blog
      </a>
      <a href="/about" style={{
      marginRight: '20px'
    }} data-id="element-1277">
        About
      </a>
      <a href="/faq" style={{
      marginRight: '20px'
    }} data-id="element-1278">
        FAQ
      </a>
    </nav>;
}